<template>
  <tr :class="classes">
    <td v-for="(column,key) in columns" :class="alignClasses(column, row)" :key="key" @mouseenter.stop="isEllipsis($event,column)">
      <t-table-cell
        :prefix-table-class="prefixTableClass"
        :tree-data="treeData"
        :row="row"
        :key="column.key"
        :column="column"
        :natural-index="row._nativeIndex"
        :index="row._index"
        :checked="isChecked"
        :disabled="isDisabled"
        :expanded="isExpanded"
        :all-ellipsis="allEllipsis"></t-table-cell>
    </td>
  </tr>
</template>
<script>
import TTableCell from './cell.vue'
import Mixin from './mixin'

export default {
  name: 'TTableRow',
  components: {TTableCell},
  mixins: [ Mixin ],
  props: {
    columns: Array,
    row: Object,
    index: Number,
    prefixTableClass: String,
    treeData: Object,
    fixed: {
      type: [ Boolean, String ],
      default: false
    },
    allEllipsis: Boolean
  },
  data: function () {
    return {}
  },
  computed: {
    classes () {
      return [
        `${this.prefixTableClass}__row`,
        this.getRowClassName(),
        {
          [`${this.prefixTableClass}__row--highlight`]: this.row._isHighlight
        }
      ]
    },
    isChecked () {
      return this.row && this.row._checked
    },
    isDisabled () {
      return this.row && this.row._isDisabled
    },
    isExpanded () {
      return this.row && this.row._isExpanded
    }
  },
  mounted () {
    // 除了settimeout 需要找更好的方法
    setTimeout(() => {
      let maxHeight = this.$el.offsetHeight
      this.$emit('row-height-correction', maxHeight, this.fixed, this.row._index)
    }, 500)
  },
  updated () {
    let maxHeight = this.$el.offsetHeight
    this.$emit('row-height-correction', maxHeight, this.fixed, this.row._index)
  },
  methods: {
    getRowClassName () {
      return this.$parent.$parent.getRowClassName(this.row._index)
    },
    isEllipsis (event, column) {
      const $current = event.currentTarget
      const $targetParent = $current.querySelector('.table__cell--ellipsis')
      const $target = $current.querySelector('.table__cell--ellipsis .table__cell--text--inner')
      if ($target && $targetParent.scrollWidth > $targetParent.offsetWidth) { // 判断是否有文字缩略
        this.$set(column, '_isEllipsis', true)
      } else {
        this.$set(column, '_isEllipsis', false)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// table-row.vue?df2a87c0